module.exports = __webpack_public_path__ + "img/Estimate.79962d5a.png";